import tasksService from '../services/tasksService.js';
import dataModel from '../models/DataModel';
import OfflineQueue from './queue/OfflineQueue';
import DAO from './DAO.js';
import StoreItemProcessing from '../helpers/StoreFunctions/StoreItemProcessing';
import Metadata from '../helpers/metadata/Metadata';
import ReduxConstants, { RecordStates } from '../constants/ReduxConstants.js';
import _ from 'lodash';

export const task_root = {
  task: {
    completion_criteria: {
      attachments: { conversions: {}, additionalFields: ['upload', 'photo_longitude', 'photo_latitude', 'photo_taken_at'] } ,
      comments: { user: { additionalFields: ['profile_image'] } },
      event_histories: { activity: {}, activity_sub_type: {}, user_who_performed_action: {} },
      form_fields: {},
    },
    reference_documents: {},
    user_task_assignments: {
      user: { additionalFields: ['profile_image'], 
        companies: {},
      },
    },
    build_owners: { companies: {} },
    inventory_items: {  inventory: {} },
    event_histories: { activity: {}, activity_sub_type: {}, user_who_performed_action: {} },
  },
};

export const task_flat = {
  task: {
    user_task_assignments: {
      user: { additionalFields: ['profile_image'], 
        companies: {},
      },
    },
    build_owners: { companies: {} },
  },
};

export const task_complete = {
  task: {
    completion_criteria: {
      attachments: { conversions: {}, additionalFields: ['upload', 'photo_longitude', 'photo_latitude', 'photo_taken_at'] } ,
      comments: { user: { additionalFields: ['profile_image'] } },
      event_histories: { activity: {}, activity_sub_type: {}, user_who_performed_action: {} },
      form_fields: {},
    },
    reference_documents: {},
    user_task_assignments: {
      user: { additionalFields: ['profile_image'], 
        companies: {},
      },
    },
    build_owners: { companies: {} },
    inventory_items: {  inventory: {} },
    event_histories: { activity: {}, activity_sub_type: {}, user_who_performed_action: {} },
  },
};

export const task_attributes = {
  task: {
  },
};

export const project_template_task_root = {
  task: {
    completion_criteria: {
      attachments: { additionalFields: ['upload', 'photo_longitude', 'photo_latitude', 'photo_taken_at'] },
      form_fields: {},
    },
    reference_documents: {},
  },
};

export const attributes_task_root = {
  task: {
    user_task_assignments: { user: { additionalFields: ['profile_image'] } },
  },  
};

export default class TasksDAO extends DAO {

  /*************************************************************
   *
   *  Initialization
   *
   *************************************************************/

  constructor(store) {
    super(store, 'task');
    this.OfflineQueue = OfflineQueue;
    this.pendingTaskRequests = new Map();

    this.unsetTask = this.unsetTask.bind(this);
    this.clearTasks = this.clearTasks.bind(this);
    this.mapToReturn = this.mapToReturn.bind(this);
    this.markDirty = this.markDirty.bind(this);
    this.checkTaskCollections = this.checkTaskCollections.bind(this);
    this.approveTask = this.approveTask.bind(this);
    this.reviewTask = this.reviewTask.bind(this);
    this.completeTask = this.completeTask.bind(this);
    this.markTaskNA = this.markTaskNA.bind(this);
    this.unmarkTaskNA = this.unmarkTaskNA.bind(this);
    this.unmarkTaskNA = this.unmarkTaskNA.bind(this);
    this.setStatus = this.setStatus.bind(this);
    this.setCompletionStepFields = this.setCompletionStepFields.bind(this);
  }

  unsetTask(taskId) {
    StoreItemProcessing.deleteItemInStore(this.itemType, taskId);
  }

  clearTasks() {
    StoreItemProcessing.clearItemsInStore(this.itemType);
  }

  mapToReturn(task, options) {
    if (!options || !options.recordDescriptor) {
      return task;
    }
    else if (task) {
      const returnItem = StoreItemProcessing.denormalizeItem(this.itemType, task, options.recordDescriptor.task);
      if (returnItem.completion_criteria) {
        returnItem.completion_criteria.sort((cc1, cc2) => {
          return cc1.order < cc2.order ? -1 : cc1.order > cc2.order ? 1 : 0;
        });
      }
      return returnItem;
    }
    else{
      return null;
    }
  }
 
  markDirty(task, dirtyState) {
    super.markDirty(task, dirtyState);

    // Make/unmark parents

    if (task.project_id) {
      const project = dataModel.projectsDAO.findItem(task.project_id); 
      if (project) {
        dataModel.projectsDAO.markDirty(project, dirtyState);
      }
    }
  }

  setStatus(task_id) {
    let task = this.findItem(task_id);
    if (task) {
      let status = {};
      if (task.completion_criteria) {
        task.completion_criteria.forEach(csId => {
          const cs = dataModel.completionCriteriaDAO.findItem(csId);
          status[cs.status] = cs.status;
        });
      }
      if (status.rejected) {
        task.status = 'in_progress';
      }
      else if (status.not_started) {
        if (!status.pending_review && !status.pending_approval && !status.approved && !status.complete && !status.completed) {
          task.status = 'not_started';
        }
        else {
          task.status = 'in_progress';
        }
      }
      else if (status.in_progress) {
        task.status = 'in_progress';
      }
      else if (status.pending_review) {
        task.status = 'pending_review';
      }
      else if (status.pending_approval) {
        task.status = 'pending_approval';
      }
      else if (status.approved) {
        task.status = 'completed';
      }
      else if (status.complete) {
        task.status = 'completed';
      }
      else {
        task.status = 'not_started';
      }
      this.setItemInStore(task);
      dataModel.actionCableConnector.internalUpdate({ type: 'updateTask', task_id: task.id }, task.id);
    }
  }

  setCompletionStepFields(taskId, fields) {
    let task = this.findItem(taskId);
    if (task.completion_criteria) {
      task.completion_criteria.forEach(ccId => {
        let cc = dataModel.completionCriteriaDAO.findItem(ccId);
        if (cc) {
          for (let field in fields) {
            if (field) {
              cc[field]= fields[field];
            }
          }
          cc.status = dataModel.completionCriteriaDAO.getStatus(cc, task);
          dataModel.completionCriteriaDAO.setItemInStore(cc);
          dataModel.actionCableConnector.internalUpdate({ type: 'updateStep', step_id: cc.id }, cc.id);
        }
      });
    }
  }

  getTask(taskId, options, prefetchCallback, ignoreError) {
    return this._getItem(taskId, tasksService.getTask.bind(this, taskId, options), options, this.mapToReturn, null, prefetchCallback, ignoreError);
  }

  // refactor_todo_maybe Bring up to date with new patterns
  getOfflineFilteredTasks(project_id, statusFilter) {
    let tasks = [];
    for (let key in this.stateTree.new_tasks) {
      if (key && this.stateTree.new_tasks[key]) {
        const task = this.denormalizeItem(this.stateTree.new_tasks[key], task_flat);
        if (task.user_task_assignments && task.user_task_assignments.find(uta => { return uta.user_id == dataModel.usersDAO.currentUser.id; })) {
          if (!statusFilter || statusFilter.includes(task.status)) {
            if (!project_id || project_id == task.project_id) {
              const foundProject = dataModel.projectsDAO.findItem(task.project_id);
              if (foundProject && (foundProject.is_offline_project || foundProject._dirty)) {
                tasks.push(task);
              }
            }
          }
        }
      }
    }
    return tasks;
  }

  markTasksNeedsSync() {
    const storeItemType = StoreItemProcessing.mapToStoreName('task');
    let stateTree = this.stateTree;
    const storeForItemType = stateTree[StoreItemProcessing.mapToReducer(storeItemType)];
    for (let task_id in storeForItemType) {
      if (task_id) {
        let task = this.findItem(task_id);
        if (task) {
          task._recordState = RecordStates.NEEDS_SYNC;
          this.setItemInStore(task);
        }
      }
    }
  }

  /* TASK CRUD FUNCTIONS */
  handleResponse(task, response, activity, errorMessage, user, eventMetadatum, options) {
    if (response.offline) {
      this.handleOfflineResponse({ user, task, taskId: task.id }, activity, eventMetadatum, options);
      this.throwItemError();
    }
    else if (response.error) {
      dataModel.displayHTTPError(errorMessage, response.error, false);
      this.markError(task);
      this.throwItemError();
    }
    else {
      this.markDirty(task, false);
      this.normalizeAndSyncToStore(response);
      const returnTask = this.mapToReturn(this.findItem(task.id), options);
      return returnTask;
    }
  }

  handleOfflineResponse(itemsForQueue, activity, eventMetadatum, options) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    this.markDirty(itemsForQueue.task, true);
    this.OfflineQueue.addQueueItem(this.itemType, activity, { ...itemsForQueue, eventMetadatum, options });

    return itemsForQueue.task;
  }

  /**
  * @param  {object <task>} task - denormalized task to create
  * @param  {object <object>} options.recordDescriptor - used to format returned task
  * 
  * @returns {object<Promise<task>>} task - denormalized task
  */
  createTask(task, eventMetadatum, options) {
    return new Promise((resolve) => {
      if (task.build_id) {
        let build = dataModel.buildsDAO.findItem(task.build_id);
        if (build.tasks) {
          build = dataModel.buildsDAO.denormalizeItem(build, { build: { tasks: {} } });
          build.tasks.push(task);
          dataModel.buildsDAO.normalizeItem(build, { recordDescriptor: { build: { tasks: {} } } });
          dataModel.actionCableConnector.internalUpdate({ type: 'updateBuild', build_id: build.id }, build.id);
        }
      }
      if (task.project_id) {
        let project = dataModel.projectsDAO.findItem(task.project_id);
        if (project.tasks) {
          project = dataModel.projectsDAO.denormalizeItem(project, { project: { tasks: {} } });
          project.tasks.push(task);
          dataModel.projectsDAO.normalizeItem(project, { recordDescriptor: { project: { tasks: {} } } });
          dataModel.actionCableConnector.internalUpdate({ type: 'updateProject', project_id: project.id }, project.id);
        }
      }
      else if (task.project_template_id) {
        let project_template = dataModel.projectTemplatesDAO.findItem(task.project_template_id);
        if (project_template.tasks) {
          project_template = dataModel.projectTemplatesDAO.denormalizeItem(project_template, { project_template: { tasks: {} } });
          project_template.tasks.push(task);
          dataModel.projectTemplatesDAO.normalizeItem(project_template, { recordDescriptor: { project_template: { tasks: {} } } });
          dataModel.actionCableConnector.internalUpdate({ type: 'updateProjectTemplate', project_template_id: project_template.id }, project_template.id);
        }
      }
      return resolve(tasksService.createTask(task, eventMetadatum, options).then(createdTask => {
        if (createdTask.error) {
          dataModel.displayHTTPError('Creating a task', createdTask.error, false);
          this.throwItemError('Error creating a task', createdTask);
        }
        else {
          this.normalizeAndSyncToStore(createdTask);
          return this.mapToReturn(this.findItem(createdTask.data.id), options);
        }
      })
        .catch((error) => {
          this.throwItemError();
        }));
    });
  }

  /*
  * @param  {object <task>} task - denormalized task to update
  * @param  {object <object>} options.recordDescriptor - used to format returned task
  * 
  * @returns {object<Promise<task>>} task - denormalized task
  */
  async updateTask(task, eventMetadatum, options) {
    return new Promise((resolve) => {
      //order matters, normalize first, set pending status
      const normalizedTask = this.normalizeItem(task, { store: true });

      this.markPending(normalizedTask);

      dataModel.actionCableConnector.internalUpdate({ type: 'updateTask', task_id: task.id }, task.id);

      if (dataModel.isOffline) {
        return resolve (this.handleOfflineResponse({ task, taskId: task.id }, 'update', eventMetadatum, options));
      }
      else {
        return resolve(tasksService.updateTask(normalizedTask, eventMetadatum, options).then(response => {
          return this.handleResponse(task, response, 'update', 'Updating a task', null, eventMetadatum, options);
        })
          .catch((error) => {
            this.markError(task);
            this.throwItemError();
          }));
      }
    });
  }

  /*
* @param  {object <task>} task - denormalized task to update
* @param  {object <object>} options.recordDescriptor - used to format returned task
* @param  {build_id <number>} build to save task to
* 
* @returns {object<Promise<task>>} task - denormalized task
*/
  async copyTask(task, build_id, eventMetadatum, options) {
    if (dataModel.isOffline) {
      this.handleOfflineResponse({ task, taskId: task.id, buildId: build_id }, 'copy', eventMetadatum, options);
      this.throwItemError();
    }
    else {
      return tasksService.copyTask(task, build_id, eventMetadatum, options).then(response => {
        task.id = +response.data.id;
        return this.handleResponse(task, response, 'copyTask', 'Copying a task', null, eventMetadatum, options);
      })
        .catch((error) => {
          this.markError(task);
          this.throwItemError();
        });
    }
  }

  /**
  * @param  {number} taskId - task record identifier
  * 
  * @returns {object<Promise<string>>} result - "offline", "error", "success"
  */
  deleteTask(taskId, eventMetadatum, onSuccessDeletionTask) {
    //TODO: action cable //LOOK OVER CAREFULLY
    let task = this.findItem(taskId);
    if (task && task.build_id) {
      let build = dataModel.buildsDAO.findItem(task.build_id);
      if (build && build.tasks) {
        build = dataModel.buildsDAO.denormalizeItem(build, { build: { tasks: {} } });
        build.tasks = build.tasks.filter(t => {return t.id != task.id;});
        dataModel.buildsDAO.normalizeItem(build, { store: true });
        dataModel.actionCableConnector.internalUpdate({ type: 'updateBuild', build_id: build.id }, build.id);
      }
    }
    if (task && task.project_id) {
      let project = dataModel.projectsDAO.findItem(task.project_id);
      if (project.tasks) {
        project = dataModel.projectsDAO.denormalizeItem(project, { project: { tasks: {} } });
        project.tasks = project.tasks.filter(t => {return t.id != task.id;});
        dataModel.projectsDAO.normalizeItem(project, { store: true });
        dataModel.actionCableConnector.internalUpdate({ type: 'updateProject', project_id: project.id }, project.id);
      }
    }
    else if (task && task.project_template_id) {
      let project_template = dataModel.projectTemplatesDAO.findItem(task.project_template_id);
      if (project_template.tasks) {
        project_template = dataModel.projectTemplatesDAO.denormalizeItem(project_template, { project_template: { tasks: {} } });
        project_template.tasks = project_template.tasks.filter(t => {return t.id != task.id;});
        const normalizedProjectTemplate = dataModel.projectTemplatesDAO.normalizeItem(project_template, { recordDescriptor: { project_template: { tasks: {} } } });
        dataModel.projectTemplatesDAO.setItemInStore(normalizedProjectTemplate, { store: true });
      }
    }
    if (task) {
      this.unsetTask(taskId);
    }
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }

    if (dataModel.isOffline) {
      this.OfflineQueue.addQueueItem(this.itemType, 'delete', { taskId, eventMetadatum });
      this.throwItemError();
    } 
    else {
      return tasksService.deleteTask(taskId, eventMetadatum).then(response => {
        onSuccessDeletionTask && onSuccessDeletionTask(task.build_id);    
        if (response.error && !response.offline) {
          dataModel.displayHTTPError('Deleting a task', response.error, false);

          if (task) {
            const normalizedTask = this.normalizeItem(task, { recordDescriptor: task_attributes });
            this.markError(normalizedTask);
            this.setItemInStore(normalizedTask);
          }
          this.throwItemError();
        }
        else if (response.offline) {
          this.OfflineQueue.addQueueItem(this.itemType, 'delete', { taskId, eventMetadatum });
          this.throwItemError();
        }
        else {          
          const build = dataModel.buildsDAO.findItem(task.build_id);
          if (build) {
            if (build.tasks) {
              const taskIndex = build.tasks.indexOf(taskId);
              if (taskIndex >= 0) {
                build.tasks.splice(taskIndex, 1);
                StoreItemProcessing.setItemInStore('build', build);
              }
            }
          }
          dataModel.displayInfoErrorMessage('The task was successfully deleted.', 4000, 1);
          return this.mapToReturn(task, { recordDescriptor: task_root });
        } 
      })
      .catch((error) => {
        this.markError(task);
        this.throwItemError();
      });
    }
  }

  // TODO: would this make more sense in the buildsDAO?
  reorderTasks(reorderList, build) {
    // dataModel.buildsDAO.markNeedsSync(build)
    return new Promise(async resolve => {
      if (reorderList && reorderList.length > 0) {
        reorderList.forEach(task => {
          build.tasks.forEach(task2 => {
            if (task2.id == task.id) {
              task2.order = task.order;
            }
          });
        });
        build.tasks.sort((t1, t2) => {
          return t1.order < t2.order ? -1 : t1.order > t2.order ? 1 : 0;
        });
        dataModel.buildsDAO.normalizeItem(build, { store: true });
        dataModel.actionCableConnector.internalUpdate({ type: 'updateBuild', build_id: build.id }, build.id);
        let reorderPairs = reorderList.map(task => { return { id: task.id, order: task.order }; });
        tasksService.reorderTasks(reorderPairs, build.id).then(response => {
        });
        resolve(reorderPairs);
      }
      else {
        resolve(null);
      }
    });
  }

  /* REFERENCE DOCUMENTS */
  addReferenceDocument(docId, taskId, eventMetadatum, options) {
    return new Promise((resolve) => {
      const task = this.findItem(taskId);
      if (!task) {
        this.throwItemError();
      }

      if (!task.reference_documents) {
        task.reference_documents = [];
      }

      if (!eventMetadatum) {
        eventMetadatum = Metadata.generateMetadatum();
      }

      task.reference_documents.push(docId);
      this.setItemInStore(task);
      dataModel.actionCableConnector.internalUpdate({ type: 'updateStep', task_id: task.id }, task.id);  

      if (dataModel.isOffline) {
        this.markDirty(task, true);
        this.OfflineQueue.addQueueItem('task', 'add_doc', { docId, taskId, eventMetadatum });
        return Promise.resolve(task);
      }
      else {
        return resolve(tasksService.addReferenceDocument(taskId, docId, eventMetadatum).then(response => {
          return this.handleResponse(task, response, 'add_doc', 'Adding a reference document', null, eventMetadatum, options);
        })
          .catch((error) => {
            this.markError(task);
            this.throwItemError();
          }));
      }
    });
  }

  removeReferenceDocument(docId, taskId, eventMetadatum, options) {
    return new Promise((resolve) => {
      const task = this.findItem(taskId);
      if (!task) {
        this.throwItemError();
      }

      if (task.reference_documents) {
        task.reference_documents = task.reference_documents.filter(refDocId => {
          return refDocId != docId;
        });
      }

      if (!eventMetadatum) {
        eventMetadatum = Metadata.generateMetadatum();
      }

      this.setItemInStore(task);
      dataModel.actionCableConnector.internalUpdate({ type: 'updateStep', task_id: task.id }, task.id);  

      if (dataModel.isOffline) {
        this.markDirty(task, true);
        this.OfflineQueue.addQueueItem('task', 'remove_doc', { docId, taskId, eventMetadatum });
        return Promise.resolve(task);
      }
      else {
        return resolve(tasksService.deleteReferenceDocument(taskId, docId, eventMetadatum).then(response => {
          return this.handleResponse(task, response, 'remove_doc', 'Removing a reference document', null, eventMetadatum, options);
        })
          .catch((error) => {
            this.markError(task);
            this.throwItemError();
          }));
      }
    });
  }

  reviewTask(task, eventMetadatum, options) {
    return new Promise((resolve) => {

      this.setCompletionStepFields(task.id, { reviewed_at: new Date().toJSON() });

      task.status = this.setStatus(task.id);
      const normalizedTask = this.normalizeItem(task, { store: true });
      dataModel.actionCableConnector.internalUpdate({ type: 'updateTask', task_id: task.id }, task.id);  

      if (dataModel.isOffline) {
        return resolve(this.handleOfflineResponse({ task, taskId: task.id }, 'review', eventMetadatum, options));
      }
      else {
        return resolve(tasksService.reviewTask(normalizedTask, eventMetadatum, options).then(response => {
          return this.handleResponse(task, response, 'review', 'Reviewing a task', null, eventMetadatum, options);
        })
          .catch((error) => {
            this.markError(task);
            this.throwItemError();
          }));
      }
    });
  }

  approveTask(task, eventMetadatum, options) {
    return new Promise((resolve) => {

      this.setCompletionStepFields(task.id, { approved_at: new Date().toJSON() });

      task.status = this.setStatus(task.id);
      const normalizedTask = this.normalizeItem(task, { store: true });
      dataModel.actionCableConnector.internalUpdate({ type: 'updateTask', task_id: task.id }, task.id);  

      if (dataModel.isOffline) {
        return resolve(this.handleOfflineResponse({ task, taskId: task.id }, 'approve', eventMetadatum, options));
      }
      else {
        return resolve(tasksService.approveTask(normalizedTask, eventMetadatum, options).then(response => {
          return this.handleResponse(task, response, 'approve', 'Approving a task', null, eventMetadatum, options);
        })
          .catch((error) => {
            this.markError(task);
            this.throwItemError();
          }));
      }
    });
  }

  completeTask(task, eventMetadatum, options) {
    return new Promise((resolve) => {

      this.setCompletionStepFields(task.id, { completed_at: new Date().toJSON() });

      task.status = this.setStatus(task.id);
      const normalizedTask = this.normalizeItem(task, { store: true });
      dataModel.actionCableConnector.internalUpdate({ type: 'updateTask', task_id: task.id }, task.id);  

      if (dataModel.isOffline) {
        return resolve(this.handleOfflineResponse({ task, taskId: task.id }, 'approve', eventMetadatum, options));
      }
      else {
        return resolve(tasksService.completeTask(normalizedTask, eventMetadatum, options).then(response => {
          return this.handleResponse(task, response, 'complete', 'Completing a task', null, eventMetadatum, options);
        })
          .catch((error) => {
            this.markError(task);
            this.throwItemError();
          }));
      }
    });
  }

  markTaskNA(task, eventMetadatum, options) {
    return new Promise((resolve) => {

      this.setCompletionStepFields(task.id, { completed_at: new Date().toJSON(), response: 'N/A', not_applicable: true });

      task.status = this.setStatus(task.id);
      const normalizedTask = this.normalizeItem(task, { store: true });
      dataModel.actionCableConnector.internalUpdate({ type: 'updateTask', task_id: task.id }, task.id);  

      if (dataModel.isOffline) {
        return resolve(this.handleOfflineResponse({ task, taskId: task.id }, 'markNA', eventMetadatum, options));
      }
      else {
        return resolve(tasksService.markTaskNA(normalizedTask, eventMetadatum, options).then(response => {
          return this.handleResponse(task, response, 'marKNA', 'Marking a task "Not Applicable"', null, eventMetadatum, options);
        })
          .catch((error) => {
            this.markError(task);
            this.throwItemError();
          }));
      }
    });
  }

  unmarkTaskNA(task, eventMetadatum, options) {
    return new Promise((resolve) => {

      this.setCompletionStepFields(task.id, { completed_at: null, response: null, not_applicable: false });

      task.status = this.setStatus(task.id);
      const normalizedTask = this.normalizeItem(task, { store: true });
      dataModel.actionCableConnector.internalUpdate({ type: 'updateTask', task_id: task.id }, task.id);  
      
      if (dataModel.isOffline) {
        return resolve(this.handleOfflineResponse({ task, taskId: task.id }, 'unmarkNA', eventMetadatum, options));
      }
      else {
        return resolve(tasksService.unmarkTaskNA(normalizedTask, eventMetadatum, options).then(response => {
          return this.handleResponse(task, response, 'unmarKNA', 'Unmarking a task "Not Applicable"', null, eventMetadatum, options);
        })
          .catch((error) => {
            this.markError(task);
            this.throwItemError();
          }));
      }
    });
  }

  bulkAssign(bulkAssignments) {

    // Check errors

    const userId = bulkAssignments.user_id;
    const taskIds = bulkAssignments.tasks;

    let userErrors = [];

    const user = dataModel.usersDAO.mapToReturn(dataModel.usersDAO.findItem(userId), { recordDescriptor: { user: { profile_image: {} } } });

    bulkAssignments.tasks = taskIds.filter(taskId => {
      const task = this.mapToReturn(this.findItem(taskId), { recordDescriptor: { task: { user_task_assignments: {} } } });
      if (task) {

        if (task.user_task_assignments && task.user_task_assignments.length) {
          const errors = task.user_task_assignments.filter(uta => {
            if (uta.user_id == userId){
              if (uta.assignment_type == bulkAssignments.assignment_type) {
                return true;
              }
              else if (uta.assignment_type != 'notify' && bulkAssignments.assignment_type != 'notify') {
                if (!userErrors.find(ue => { return ue.id == userId; })) {
                  userErrors.push(user);
                }
                return true;
              }
              else {
                return false;
              }
            }
            else {
              return false;
            }
          });
          if (errors.length) {
            return false;
          }
          else {
            return true;
          }
        }
        else {
          return true;
        }
      }
      else {
        return false;
      }
    });

    if (bulkAssignments.tasks.length == 0) {
      return new Promise(resolve => {
        return resolve(userErrors);
      });
    }
    else {
      let tempId = -1;
      bulkAssignments.tasks.forEach(taskId => {
        const task = this.mapToReturn(this.findItem(taskId), { recordDescriptor: { task: { user_task_assignments: {} } } });
        if (!task.user_task_assignments) {
          task.user_task_assignments = [];
        }
        task.user_task_assignments.push({ id: tempId--, user_id: bulkAssignments.user_id, task_id: task.id, assignment_type: bulkAssignments.assignment_type });
        this.normalizeItem(task, { store: true });
        dataModel.actionCableConnector.internalUpdate({ type: 'updateTask', task_id: task.id }, task.id);  
      });

      return tasksService.bulkAssign(bulkAssignments).then(response => {
        if (response.error) {
          dataModel.displayHTTPError('Doing a bulk assign', response.error, false);
        }
        return userErrors;
      })
        .catch((error) => {
          this.throwItemError();
        });
    }
  }

  addFieldUserToTask(user, task, eventMetadatum, options) {
    return new Promise((resolve) => {
      const normalizedTask = this.normalizeItem(task, { store: true });
      dataModel.actionCableConnector.internalUpdate({ type: 'updateTask', task_id: task.id }, task.id);  

      if (dataModel.isOffline) {
        return resolve(this.handleOfflineResponse({ user, task, taskId: task.id }, 'add_field_user', eventMetadatum, options));
      }
      else {
        return resolve(tasksService.createFieldUser(normalizedTask, { id: user.id }, eventMetadatum).then(response => {
          return this.handleResponse(task, response, 'add_field_user', 'Adding user to task', user, options);
        })
          .catch((error) => {
            this.markError(task);
            this.throwItemError();
          }));
      }
    });
  }

  removeFieldUserFromTask(user, task, eventMetadatum, options) {
    return new Promise((resolve) => {
      if (dataModel.isOffline) {
        return resolve(this.handleOfflineResponse({ user, task, taskId: task.id }, 'remove_field_user', eventMetadatum, options));
      }
      else {
        return resolve(tasksService.deleteFieldUser(task, { id: user.id }, eventMetadatum).then(response => {
          return this.handleResponse(task, response, 'remove_field_user', 'Removing user from task', user, options);
        })
          .catch((error) => {
            this.markError(task);
            this.throwItemError();
          }));
      }
    });
  }

  get creationIndex() {
    if (!this._creationIndex) {
      this._creationIndex = 0;
    }
    this._creationIndex--;
    return this._creationIndex;
  }

  updateTaskDependency(task, task_dependent_on, options) {
    return new Promise((resolve) => {
      if (task_dependent_on && task) {
        task.task_dependencies = { task, task_dependent_on };
        this.normalizeItem(task, { store: true });
        dataModel.actionCableConnector.internalUpdate({ type: 'updateTask', task_id: task.id }, task.id);
        return resolve(tasksService.updateTaskDependencies(task, task_dependent_on, options).then(response => {
          return this.handleResponse(task, response, 'update_task_dependencies', 'Updating a task', null, null, options);
        }));
      }
      else {
        return Promise.resolve(task);
      }
    });
  }

  updateTaskAssignments(task, options) {
    return new Promise((resolve) => {
      if (dataModel.isOffline) {
        this.markDirty(task, true);
        this.offlineQueue.addQueueItem('task', 'update_assignments', { task, taskId: task.id });
        return Promise.resolve(task);
      }
      let assignmentList = [];
      for (let assignment of task.user_task_assignments) {
        if (assignment.toBeAdded || assignment.toBeDeleted) {
          let userAssignment = { assignment_type: assignment.assignment_type, user_id: assignment.user.id };
          if (assignment.toBeDeleted) {
            userAssignment.remove = true;
            userAssignment.id = assignment.id;
          }
          assignmentList.push(Object.assign({}, userAssignment));
        }
      }
      if (assignmentList.length > 0) {
        task.user_task_assignments = task.user_task_assignments.filter(uta => {
          if (!uta.user_id) {
            uta.user_id = uta.user.id;
          }
          if (!uta.id) {
            uta.id = this.creationIndex;
          }
          if (!uta.toBeDeleted) {
            return true;
          }
          else {
            delete uta.toBeDeleted;
            delete uta.toBeAdded;
          }
          return false;
        });
        this.normalizeItem(task, { store: true });
        dataModel.actionCableConnector.internalUpdate({ type: 'updateTask', task_id: task.id }, task.id);
        return resolve(tasksService.updateTaskAssignments(task, assignmentList, options).then(response => {
          return this.handleResponse(task, response, 'update_assignments', 'Updating a task', null, null, options);
        }));
      }
      else {
        return Promise.resolve(task);
      }
    });
  }

  findTask(taskId) {
    return this.stateTree.new_tasks[taskId];
  }
 /* Util Functions */
  completeOfflineUpdate(queueItem) {
    const task = this.findTask(queueItem.itemInfo.taskId);
    if (!task) {
      return false;
    }
    
    const eventMetadatum = queueItem.itemInfo.eventMetadatum;
    const options = queueItem.itemInfo.options;
    switch (queueItem.operationKey) {
      // TODO: arguments in these calls don't match up and there are unimplemented functions
    case 'update':
      return this.updateTask(task, eventMetadatum, options);
    case 'create':
      return this.createTask(task, eventMetadatum, options);
    case 'remove_doc':
      return this.removeReferenceDocument(queueItem.itemInfo.docId, queueItem.itemInfo.taskId, eventMetadatum, options);
    case 'add_doc':
      return this.addReferenceDocument(queueItem.itemInfo.docId, queueItem.itemInfo.taskId, eventMetadatum, options);
    case 'delete':
      return this.deleteTask(queueItem.itemInfo.taskId, eventMetadatum, options);
    case 'review':
      return this.reviewTask(queueItem.itemInfo.task, eventMetadatum, options);
    case 'approve':
      return this.approveTask(queueItem.itemInfo.task, eventMetadatum, options);
    case 'complete':
      return this.completeTask(queueItem.itemInfo.task, eventMetadatum, options);
    case 'remove_field_user':
      return this.removeFieldUserFromTask(queueItem.itemInfo.user, queueItem.itemInfo.task, queueItem.itemInfo.userId, eventMetadatum, options);
    case 'add_field_user':
      return this.addFieldUserToTask(queueItem.itemInfo.user, queueItem.itemInfo.task, eventMetadatum, options);
    case 'update_assignments':
      return this.updateTaskAssignments(queueItem.itemInfo.task, options);
    case 'markNA':
      return this.markTaskNA(queueItem.itemInfo.task, eventMetadatum, options);
    case 'unmarkNA':
      return this.unmarkTaskNA(queueItem.itemInfo.task, eventMetadatum, options);
    default:
      break;
    }
    return true;
  }

  checkTaskCollections(task_id) {
    let collectionIds = dataModel.collectionsDAO.getCollectionsByType(ReduxConstants.TASK);
    for (let collectionId of collectionIds) {
      let collection = dataModel.collectionsDAO.findCollection(collectionId);
      if (collection) {
        // if (collection.collection.ids.find(id => {return id == task_id})){
        collection._recordState = RecordStates.NEEDS_SYNC;
        dataModel.collectionsDAO.setCollection(collectionId, collection, ReduxConstants.TASK);
        // }
      }
    }
  }

  handleActionCableAndGetRequest(acData) {
    const task = this.findItem(acData.task_id);
    if (task) {
      if (acData.is_attribute_update) {
        this.markNeedsAttributeSync(task);
      }
      else {
        this.markNeedsSync(task);
      }

      // To be handled by the CollectionsDAO
      // this.checkTaskCollections(task.id)
    }
    switch (acData.type) {
    case 'newTask':
    case 'updateTask':
    case 'updateTaskAssignments':
      return this.getTask.bind(this);
    case 'deleteTask':
        // TODO - how to handle deletes?
        // return this.deleteTaskInStore.bind(this, acData.task_id)
      break;
    default:
    }
  }

  clearState(options) {
    this.clearMyState(this.stateTree.new_tasks, options.toIgnore.tasks, this.unsetTask, this.clearTasks, options);
  }
}



// WEBPACK FOOTER //
// ./src/dao/TasksDAO.js